import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    const loadingService = inject(LoadingService);

    // Skip loader for background requests if needed (via headers or params)
    const skipLoader = req.params.get('skipLoader') === 'true';

    if (!skipLoader) {
        loadingService.show();
    }

    return next(req).pipe(
        finalize(() => {
            if (!skipLoader) {
                loadingService.hide();
            }
        })
    );
};
